import { locales, getCurrentLocale } from '../i18n';
import { ILanguageObject } from './types';

export const getLocaleString = (object: ILanguageObject) => {
  const currentLocale = getCurrentLocale();

  if (currentLocale && object[currentLocale]) return object[currentLocale];

  const otherLanguage = locales.find((language) => !!object[language]);
  return otherLanguage || '';
};
